import SponsorListView from "@/views/admin/sponsors/SponsorListView";

export default [
  {
    name: "pages.admin.sponsors",
    path: "sponsors",
    component: SponsorListView
  },
  
];
